export const FETCH_NOTIFICATIONS_REQUEST_CALLED = '@notifications/FETCH_NOTIFICATIONS_REQUEST_CALLED';
export const FETCH_NOTIFICATIONS_REQUEST_FAIL = '@notifications/FETCH_NOTIFICATIONS_REQUEST_FAIL';
export const FETCH_NOTIFICATIONS_REQUEST_SUCCEEDED = '@notifications/FETCH_NOTIFICATIONS_REQUEST_SUCCEEDED';
export const FETCH_NOTIFICATIONS_REQUEST_START = '@notifications/FETCH_NOTIFICATIONS_REQUEST_START';
export const UPDATE_NOTIFICATION_REQUEST_CALLED = '@notifications/UPDATE_NOTIFICATION_REQUEST_CALLED';
export const UPDATE_NOTIFICATION_REQUEST_START = '@notifications/UPDATE_NOTIFICATION_REQUEST_START';
export const UPDATE_NOTIFICATION_REQUEST_SUCCEEDED = '@notifications/UPDATE_NOTIFICATION_REQUEST_SUCCEEDED';
export const UPDATE_NOTIFICATION_REQUEST_FAIL = '@notifications/UPDATE_NOTIFICATION_REQUEST_FAIL';
export const CLEAR_NOTIFICATIONS = '@notifications/CLEAR_NOTIFICATIONS';

interface ChatNotification {
    chatMessageId: string
    senderName: string
}

interface User {
    avatar: string;
    'full_name': string;
    id: number;
    'user_img_path': string;
}

type Types = 'CHAT'

export interface Notification {
    actor: User
    date: Date
    payload: Partial<ChatNotification>
    target: User
    type: Types
    unread: boolean
}

interface RequestState {
    loading: boolean
}

export interface NotificationState extends RequestState {
    notifications: Notification[]
}

interface FetchNotificationsAction {
    type: typeof FETCH_NOTIFICATIONS_REQUEST_CALLED,
    actionTypes: {
        start: string
        fail: string
        success: string
    },
    config: {
        method: string
        url: string
        params: {
            after?: string
        }
    }
}

export type NotificationsTypes = FetchNotificationsAction

export interface Client {
    id: number;
    name: string;
}
